import React from "react";
import { useNavigate } from "react-router-dom";
import ascendLogo from '../../../assets/ACS-Images/Ascend-Logo.png';

const TeamOnboarding = () => {
  const navigate = useNavigate();

  return (
    <div className="w-full min-h-screen flex flex-col items-center justify-center bg-white px-4">
      {/* Logo */}
      <img
        src={ascendLogo}
        alt="Ascend Logo"
        className="w-32 md:w-40 mb-6 hover:scale-105 transition-transform duration-300"
      />

      {/* Stepper */}
      <div className="flex items-center justify-center gap-6 mt-2 mb-6">
        {["Invite your team", "FTP Location", "Success"].map((label, idx) => (
          <React.Fragment key={idx}>
            {idx > 0 && <div className="w-8 border-t-2 border-gray-300"></div>}
            <div className="flex flex-col items-center">
              <div className="w-8 h-8 rounded-full border-2 border-[#223688] bg-[#223688] text-white font-semibold flex items-center justify-center">
                {idx + 1}
              </div>
              <span className="mt-1 text-sm font-semibold text-black text-center">{label}</span>
            </div>
          </React.Fragment>
        ))}
      </div>

      {/* Thank You Message */}
      <div className="text-center max-w-xl">
        <h1 className="text-fluid-xl font-bold mb-4">Thank you for your submission!</h1>
        <p className="text-fluid-base text-gray-600">
          We are currently reviewing your submission and will get back to you within 1–2 business days about next steps.
        </p>
      </div>

      {/* Go to Login */}
      <div className="mt-10">
        <button
          onClick={() => navigate("/login")}
          className="px-10 py-2 bg-[#223688] text-white rounded-full hover:bg-[#1c2c6d] transition"
        >
          Go to login page
        </button>
      </div>
    </div>
  );
};

export default TeamOnboarding;
